import Wall from "./Wall"

export default class Summary {
    constructor(form) {
        this.form = form
    }

    sum(values) {
        return values.reduce((sum, value) => sum + value, 0)
    }

    getDependentOnLength(length, values) {
        let highest = null
        for(let min in values) {
            min = parseFloat(min)
            if(highest == null || ( min > highest && min <= length )) {
                highest = min
            }
        }
        return values[highest]
    }

    get breaks() {
        return this.sum(this.form.walls.map(wall => wall.breaks))
    }

    get bargroups() {
        return Wall.groupBy(this.form.walls, wall => `${wall.bar_color}:${wall.lighted}`)
    }

    get lightgroups() {
        return Wall.groupBy(this.form.walls.filter(wall => wall.hasNormalLighting()), wall => wall.color)
    }

    get sockelleisten() {
        return Object.keys(this.bargroups).map(name => ({
            color: name.split(':')[0],
            lighted: name.split(':')[1],
            length: this.sum(this.bargroups[name].map(wall => wall.length))
        }))
    }

    get lights() {
        return Object.keys(this.lightgroups).map(color => ({
            color,
            length: this.sum(this.lightgroups[color].map(wall => wall.length))
        }))
    }

    get formteile() {
        return {
            innenecken: this.form.formteile.innenecken,
            außenecken: this.form.formteile.außenecken,
            endkappen_links: this.breaks,
            endkappen_rechts: this.breaks,
            verbinder: this.form.formteile.verbinder,
        }
    }

    get other() {
        return {
            netzteile: this.getDependentOnLength(this.sum(this.form.walls.map(wall => wall.length)), { 0: 1, 5: 2, 10: 3, 15: 4 }),
            funkschalter: this.form.walls.filter(wall => wall.hasRemoteControl()).length
        }
    }

    getMailData() {
        return {
            sockelleisten: this.sockelleisten,
            lights: this.lights,
            formteile: this.formteile,
            other: this.other,
        }
    }
}